export default __webpack_public_path__ + "static/c9aead9a73516efe736611f813468089.png";